import styled, { keyframes } from "styled-components";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerCore = styled.div`
  border: 3px solid #f3f3f3;
  border-top: 3px solid #71adb2;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: ${spin} 0.75s linear infinite;
  margin-top: 40px;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 100vh;
`;

export const Spinner = () => {
  return (
    <SpinnerWrapper>
      <SpinnerCore />
    </SpinnerWrapper>
  );
};
